import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { i18n } from '../i18n'
import { createPinia } from 'pinia'
import GLightbox from 'glightbox'
import VReferenceSlider from '../components/VReferenceSlider.vue'
import VImageMagazineButton from '../components/VImageMagazineButton.vue'
import VImageFlipbook from '../components/VImageFlipbook.vue'
import VBackButton from '../components/VBackButton.vue'
import { app } from '../app'

const pinia = createPinia()

createApp({
  components: {
    VReferenceSlider,
    VImageMagazineButton,
    VImageFlipbook,
    VBackButton
  },
  mounted () {
    this.$nextTick(() => {
      GLightbox({ selector: '.glightbox' })
    })
  },
  extends: app
})
  .use(vuetify)
  .use(i18n)
  .use(pinia)
  .mount('#app')
